import { useEffect, useLayoutEffect } from 'react';
import reframe from 'nike-re-framejs';
import i18n from '@i18n';
import { interceptPageUpdate } from '@/menu/views/MainTabBar';
import {
    setScrollTop as desktopScrollTop,
    scrollToLastTop as desktopScrollToLastTop
} from '@/responsive/helpers/scroll';
import { VIRTUAL_GAMES } from '@/routing/routes';
import { isProfileNoBetslip } from 'nike-ui/src/profiles';

function resolvePageTitle(route) {
    if (route.component && typeof route.component.pageTitle !== 'undefined') {
        const { pageTitle } = route.component;
        // resolve by pageComponent
        if (pageTitle === null || pageTitle === '' || pageTitle === ' ' || pageTitle === ':LOGO') {
            return null;
        }
        return i18n(pageTitle);
    }
    let resolved = resolvePageTitleByPageName(route);
    if (resolved && resolved.startsWith && resolved.startsWith('react.')) {
        console.log('Unresolved page title', resolved);
        return null;
    }
    return resolved;
}

export function resolvePageTitleByPageName(route) {
    const { name } = route;
    let pageTitle = '';
    const split = name.split('kasino:');
    let key;
    if (split.length === 2) {
        key = 'react.page.title.' + split[1];
        pageTitle = i18n(key);
        if (pageTitle !== key) {
            return pageTitle;
        }
    }
    key = 'react.page.title.' + name;
    pageTitle = i18n(key);
    return pageTitle;
}

function useOnNavigateScrollTop(location, history) {
    useLayoutEffect(() => {
        if (history.action === 'PUSH') {
            window.scrollTo(0, 0);
            desktopScrollTop();
        }
        if (history.action === 'POP') {
            desktopScrollToLastTop();
        }
        // we need this effect only when pathname changes
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.pathname]);
}

function usePageTitle(route) {
    useEffect(() => {
        reframe.dispatch(['setRouteAndPageTitle', route, resolvePageTitle(route)]);
    }, [route]);
}

function useLastMenuPage(route) {
    useEffect(() => {
        interceptPageUpdate(route);
    }, [route]);
}

function useCorrectBetslip(route) {
    const isNotVirtual = route !== VIRTUAL_GAMES;
    useEffect(() => {
        if (isNotVirtual) {
            reframe.dispatch(['betslip.ensureNikeOneBetslip']);
        }
    }, [isNotVirtual]);
}

function PageInterceptor({ route, location, history }) {
    useOnNavigateScrollTop(location, history);
    usePageTitle(route);
    useLastMenuPage(route);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    isProfileNoBetslip() || useCorrectBetslip(route);
    return null;
}

export default PageInterceptor;
